// extracted by mini-css-extract-plugin
export default {"link":"pf48QQ4c","container":"blExmySF","image":"Q4pgxLJY","_narrow":"MgdBN7M2","altHeadline":"qz9MfZPM","icon":"w11B7qPp","content":"kQjnxe_D"};